import { createAction } from '@ngrx/store';

import { Address } from 'ish-core/models/address/address.model';
import { Basket } from 'ish-core/models/basket/basket.model';
import { BucketBaseData } from 'ish-core/models/bucket/bucket.interface';
import { Bucket } from 'ish-core/models/bucket/bucket.model';
import { ShippingMethod } from 'ish-core/models/shipping-method/shipping-method.model';
import { httpError, payload } from 'ish-core/utils/ngrx-creators';

export const customDeleteBasket = createAction('[Basket] Custom Delete Basket');

export const customDeleteBasketFail = createAction('[Basket API] Custom Delete Basket Fail', httpError());

export const customDeleteBasketSuccess = createAction('[Basket API] Custom Delete Basket Success');

export const customLoadBasketEligibleShippingMethodsWithBasket = createAction(
  '[Basket Internal] Load Basket Eligible Shipping Methods with Basket',
  payload<{ basket: Basket }>()
);

export const customLoadBasketWithShippingMethods = createAction('[Basket Internal] Load Basket with Shipping Methods');

export const customLoadBasketWithShippingMethodsSuccess = createAction(
  '[Basket API] Load Basket Success with Shipping Methods',
  payload<{ basket: Basket }>()
);

export const updateBasketAddressSuccess = createAction(
  '[Basket] Update an Address at Basket Success',
  payload<{ address: Address; scope?: 'invoice' | 'shipping' | 'any' }>()
);
export const redirectLoadBasket = createAction('[Basket Internal] Redirect Load Basket');
export const redirectLoadBasketFail = createAction('[Basket API] redirect Load Basket Fail', httpError());

export const redirectLoadBasketSuccess = createAction(
  '[Basket API] redirect Load Basket Success',
  payload<{ basket: Basket }>()
);

export const loadBucketEligibleShippingMethods = createAction(
  '[Multiple Shipping Basket Internal] Load Bucket Eligible Shipping Methods',
  payload<{ bucket: Bucket }>()
);

export const loadBucketEligibleShippingMethodsFail = createAction(
  '[Multiple Shipping Basket API] Load Bucket Eligible Shipping Methods Fail',
  httpError()
);

export const loadBucketEligibleShippingMethodsSuccess = createAction(
  '[Multiple Shipping Basket API] Load Bucket Eligible Shipping Methods Success',
  payload<{ bucketId: string; shippingMethods: ShippingMethod[] }>()
);

export const updateBucketShippingMethod = createAction(
  '[Multiple Shipping Basket] Update Bucket Shipping Method',
  payload<{ bucket: BucketBaseData }>()
);

export const updateBucketShippingMethodFail = createAction(
  '[Multiple Shipping Basket] Update Bucket Shipping Method Fail',
  httpError()
);

export const setBucketDesiredDeliveryDate = createAction(
  '[Multiple Shipping Basket] Add or Update Bucket Desired Delivery Date',
  payload<{ bucket: Bucket; desiredDeliveryDate: string }>() // international iso date format yyyy-mm-dd
);

export const setBucketDesiredDeliveryDateSuccess = createAction(
  '[Multiple Shipping Basket] Add or Update Bucket Desired Delivery Date Success',
  payload<{ bucket: Bucket; desiredDeliveryDate: string }>() // international iso date format yyyy-mm-dd
);

export const loadEligibleBasketAddresses = createAction('[Multiple Shipping Basket] Load Eligible Basket Addresses');

export const loadEligibleBasketAddressesSuccess = createAction(
  '[Multiple Shipping Basket] Load Eligible Basket Addresses Success',
  payload<{ addresses: Address[] }>()
);

export const loadEligibleBasketAddressesFail = createAction(
  '[Multiple Shipping Basket] Load Eligible Basket Addresses Fail',
  httpError()
);

/**
 * CUSTOMIZATION: OPC multi-ship — patch line ship-to after separate-lineitem without
 * loadBasket (avoids full-page basketLoading hang on repeated address picks).
 */
export const patchBasketLineItemShipToAddress = createAction(
  '[Multiple Shipping Basket] Patch Line Item Ship To Address',
  payload<{ itemId: string; shipToAddress: string }>()
);

export const customUpdateBasketAddress = createAction(
  '[Basket] Custom Update an Address at Basket',
  payload<{ address: Address; scope: 'invoice' | 'shipping' | 'any' }>()
);

export const setRedirectInProgress = createAction(
  '[Basket] Redirect In Progress',
  payload<{ redirectInProgress: boolean }>()
);
